/* @flow */
// A loading indicator that's centered vertically and horizontally.
import CenteredContainer from 'components/CenteredContainer.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import React from 'react';

import './styles/CenteredLoadingIndicator.scss';

class CenteredLoadingIndicator extends React.Component {
  render() {
    return (
      <CenteredContainer className="CenteredLoadingIndicator-container">
        <LoadingIndicator />
      </CenteredContainer>
    );
  }
}

export default CenteredLoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/CenteredLoadingIndicator.jsx